<span *ngIf="icon" id="icon" class="icon {{icon}}"
    [ngClass]="{'selected': selected, 'hovered': hovered, 'exceded': exceded}"></span>